import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * One page title treatment for the whole app. Before this, headings ranged from
 * text-xl to text-3xl in three different greys, centred on some screens and
 * left-aligned on others.
 *
 * `backTo` renders a real back affordance, which matters most on mobile where
 * the bottom nav only covers the top-level modules.
 */
const PageHeader = ({ title, subtitle, actions, backTo, sticky = false, className = '' }) => {
  const navigate = useNavigate();

  return (
    <div
      className={[
        'border-b border-border bg-surface',
        sticky ? 'sticky top-0 z-20' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="mx-auto w-full max-w-7xl px-4 py-3 sm:px-6 sm:py-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 items-start gap-3">
            {backTo && (
              <button
                type="button"
                onClick={() => navigate(backTo)}
                aria-label="Go back"
                className="-ml-2 flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-fg transition-colors duration-fast hover:bg-muted hover:text-foreground"
              >
                <ArrowBackIcon style={{ fontSize: 20 }} />
              </button>
            )}
            <div className="min-w-0">
              <h1 className="truncate text-xl font-semibold text-foreground sm:text-2xl">{title}</h1>
              {subtitle && <p className="mt-0.5 text-sm text-muted-fg">{subtitle}</p>}
            </div>
          </div>

          {actions && (
            // Scrolls rather than wraps into a tall stack when actions are many.
            <div className="-mx-4 flex shrink-0 items-center gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0 sm:pb-0">
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
